import { Card, CardContent, Skeleton, Box, Stack } from "@mui/material";

export default function VendasMensaisSkeleton() {
    return (
        <Card>
            <CardContent>
                {/* Título */}
                <Skeleton 
                    variant="text" 
                    width="60%" 
                    height={32} 
                    sx={{ mb: 2 }}
                />

                {/* Área do gráfico */}
                <Skeleton 
                    variant="rectangular" 
                    width="100%" 
                    height={250}
                    sx={{ mb: 2, borderRadius: 1 }}
                />

                {/* Legendas */}
                <Stack direction="row" spacing={2} justifyContent="center">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Skeleton variant="rectangular" width={16} height={16} />
                        <Skeleton variant="text" width={60} height={20} />
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Skeleton variant="rectangular" width={16} height={16} />
                        <Skeleton variant="text" width={80} height={20} />
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
}
